export const BREACH_BANK =
    {
        BANDEC_MLC: {prefix: '9225 06xx xxxx xxxx', name:'BANDEC (MLC)', brand: 'bandec_mlc'},
        BM_MLC: {prefix: '9225 95xx xxxx xxxx', name:'METROPOLITANO (MLC)', brand: 'bm_mlc'},
        BPA_MLC: {prefix: '9225 12xx xxxx xxxx', name:'BPA (MLC)', brand: 'bpa_mlc'},
        BANDEC_CUP: {prefix: '9204 06xx xxxx xxxx', name:'BANDEC (CUP)', brand: 'bandec_cup'},
        BM_CUP: {prefix: '9224 95xx xxxx xxxx', name:'METROPOLITANO (CUP)', brand: 'bm_cup'},
        BPA_CUP: {prefix: '9202 12xx xxxx xxxx', name:'BPA (CUP)', brand: 'bpa_cup'},
    }